import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Task } from '../models/task';
import { ApiService } from '../services/api.service';
import { MatButton } from '@angular/material/button';
import { MatSortHeader } from '@angular/material/sort';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CdkScrollable } from '@angular/cdk/scrolling';
@Component({
    selector: 'app-details-composants',
    templateUrl: './details-composants.component.html',
    styleUrls: ['./details-composants.component.css'],
    standalone: true,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogActions, MatButton, MatDialogClose]
})
export class DetailsComposantsComponent implements OnInit {
  displayedColumns: string[] = ['Article', 'DescLien', 'QteAllouee', 'QteReelle', 'Unit', 'DateAlloc'];
  dataSource: any;
  constructor(
    public dialogRef: MatDialogRef<DetailsComposantsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DetailsComposantsData,
    private apiService: ApiService) { }

  ngOnInit() {
    const httpParams = [{ key: 'numOf', value: this.data.task.Of }, { key: 'ofPartiel', value: this.data.task.OfPartiel }]
    this.apiService.generateHttpRequest(null, 'Gantt/GetDetailComposants', null, 'GET', httpParams)
    .subscribe(
      result => { this.dataSource = result; }
    );


  }

}
export interface DetailsComposantsData {
  task: any;
}